import { useSelectedLayoutSegments } from 'next/navigation';

// The following examples all use [/world/euro/1/t] as the current route.
export const useMenuTypeActived = () => {
	const selectedLayoutSegments = useSelectedLayoutSegments();

	const worldIndex = selectedLayoutSegments.indexOf('world');
	const [menuType, sport, market] = selectedLayoutSegments.slice(worldIndex + 1);

	/**
	 * - /world/euro/1/t => pass
	 * - /world/asian-cup/1/t => fail
	 * @returns check result
	 */
	const isMenuTypeActived = (href: string) => 
		new RegExp(`^\\/world\\/${menuType}(?:\/|$)`).test(href);
	
	/**
	 * - /world/euro/1/t => pass
	 * - /world/euro/1/outright => pass
	 * - /world/euro/2/t => fail
	 * @returns check result
	 */
	const isMenuTypeSportActived = (href: string) => 
		new RegExp(`^\\/world\\/${menuType}\\/${sport}(?:\/|$)`).test(href);
	
	return {
		isMenuTypeActived,
		isMenuTypeSportActived
	};
};